import { useContext, useEffect, useState } from 'react'
import { UserContext } from 'context/userContext'
import { Icon } from 'assets/index'
import { useFetch } from 'hooks'
import { Loading, SelectCard, Path } from 'components/index'
import { clearString } from 'helper/utils'
import { Container } from './style'
import Extract from './Extract'

export default function Extrato() {
  const { data = {}, selectedId } = useContext(UserContext)
  const [loading, setLoading] = useState(false)
  const [extractData, setExtractData] = useState()
  const [selected, setSelected] = useState('deposit')

  const api = useFetch()

  const formatData = (d: []) => {
    const formatedData: any = {}

    d.forEach((transaction: any) => {
      const date = transaction.createdAt.split('T')[0]

      if (Object.keys(formatedData).includes(date)) {
        formatedData[date].push(transaction)
      } else {
        formatedData[date] = [transaction]
      }
    })

    return formatedData
  }

  useEffect(() => {
    setLoading(true)
    api
      .fetch(
        'get',
        null,
        `/gestor/account/statement/${clearString(
          data?.user?.document
        )}?type=${selected}`
      )
      .then((response) => {
        if (!response.data) return
        console.log(response)
        setExtractData(formatData(response.data.data))
        setLoading(false)
      })
    // if (!data.wallet) throw new Error('Invalid requested data')
    // setExtractData(formatData(data.wallet.statementList))
  }, [selected])

  // if (loading) return <Loading modal />
  return (
    <Container>
      <Path className="path">
        <span className="path">{'Detalhes do cliente > Extrato'}</span>
      </Path>
      <h1 className="detalhes-captacao-title">{data.user.name}</h1>
      <div className="detalhes-container123">
        <h4 className="status-span">
          Conta {data.user.type === 'CPF' ? 'pessoa física' : 'pessoa jurídica'}
        </h4>
        <img
          className="status-icon"
          src={Icon('undefined.svg')}
          alt="status icon"
        />
        <span className="status-span">{data.account.status}</span>
      </div>

      <div className="status-card-container-cards">
        <SelectCard
          icon="wallet.svg"
          value="Depósito"
          onClick={(e: any) => setSelected('deposit')}
          checked={selected === 'deposit'}
        />
        <SelectCard
          icon="coin.svg"
          value="Saque"
          onClick={(e: any) => setSelected('pix')}
          checked={selected === 'pix'}
        />
        <SelectCard
          icon="invest.svg"
          value="Rentabilidade"
          onClick={(e: any) => setSelected('profitability')}
          checked={selected === 'profitability'}
        />
        <SelectCard
          icon="trophy.svg"
          value="Investimento"
          onClick={(e: any) => setSelected('purchase')}
          checked={selected === 'purchase'}
        />
      </div>
      {loading ? (
        <div style={{ width: '70%', minHeight: 200 }}>
          <Loading modal small />
        </div>
      ) : (
        <div className="extrato-details">
          <Extract data={extractData} />
        </div>
      )}
    </Container>
  )
}
